import React from 'react';

import ButtonLink from 'common/uiV3/Button/ButtonLink';

import 'css/components/www/_LandingCTAButtons.scss';

type Props = {
  renderDemoButton?: boolean;
};
const LandingCTAButtons = ({ renderDemoButton }: Props) => {
  return (
    <div className="landingCTAButtons">
      <ButtonLink to="/register" size="large">
        Get started
      </ButtonLink>
      {renderDemoButton && (
        <ButtonLink to="/request-demo" size="large" variant="outlined">
          Request a demo
        </ButtonLink>
      )}
    </div>
  );
};

export default LandingCTAButtons;
